/**
 * @module Postcode-Lookup Exports
 */
import { Controller, defaults } from "./controller";
import { watch } from "./watch";
import { setup, controllers } from "./setup";
/**
 * Namespace that exports Postcode Lookup methods and classes
 */
export const PostcodeLookup = {
    controllers,
    setup,
    Controller,
    defaults,
    watch,
};
export { Controller, watch };
